import React from "react";
import {
  clientsLegendItems,
  legendItemsC,
  newOrdersLegendItems,
  verificationsLegendItems,
} from "./utils/options.js";
import Drivers from "./components/Drivers.jsx";
import PieChart from "./components/PieChart.jsx";
import BarChart from "./components/BarChart.jsx";
import Donations from "./components/Donations.jsx";
import AreaChart from "./components/AreaChart.jsx";
import BestClients from "./components/BestClients.jsx";
import StackedBarChart from "./components/stackedBarChart/Index.jsx";
import MostDonatedProjects from "./components/MostDonatedProjects.jsx";
import ProjectsVerifications from "./components/ProjectsVerifications.jsx";
import { Header } from "@";

const Index = () => {
  const links = [{ name: "الاحصائيات المتقدمة", link: "" }];

  return (
    <>
      {/* Page header */}
      <Header links={links} title="الاحصائيات المتقدمة" />

      {/* Page content */}
      <main>
        <div className="grid gap-x-3 md:grid-cols-2 md:gap-x-5 xl:grid-cols-4">
          <Donations />
          <AreaChart
            prefix="ر.س"
            title="الاستقطاعات"
            queryType="recurrentOrders"
          />
          <AreaChart prefix="ر.س" title="الاهداءات" queryType="giftOrders" />
          <AreaChart
            prefix="سلة"
            title="السلات المتروكة"
            queryType="abandonedCarts"
          />
        </div>

        <StackedBarChart
          title="العملاء"
          legendItems={clientsLegendItems}
          queryType="clients"
        />
        <StackedBarChart
          title="المبيعات"
          legendItems={newOrdersLegendItems}
          queryType="newOrders"
        />

        <div className="grid gap-x-3 md:grid-cols-2 md:gap-x-5 xl:grid-cols-3">
          <PieChart
            noSelect
            legendItems={legendItemsC}
            description="أنظمة تشغيل العملاء"
            title="أنظمة التشغيل"
          />
          <PieChart
            legendItems={verificationsLegendItems}
            title="عمليات التوثيق "
            queryType="verifications"
          />
          <div className="md:col-span-2 xl:col-span-1">
            <MostDonatedProjects />
          </div>
        </div>

        <div className="grid gap-x-3 sm:grid-cols-2 md:gap-x-5">
          <BarChart title="عدد طلبات المتجر  " queryType="cardOrders" />
          <BarChart title="عمليات الحسابات البنكية  " queryType="bankOrders" />
        </div>

        <div className="grid gap-5 lg:grid-cols-2 xl:grid-cols-3">
          <BarChart
            prefix="المبلغ"
            title="التبرعات "
            queryType="ordersAmount"
          />
          <div className="xl:col-span-2">
            <BestClients />
          </div>
        </div>
        <div className="grid gap-x-3 md:gap-x-5 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <Drivers />
          </div>
          <ProjectsVerifications />
        </div>
      </main>
    </>
  );
};

export default Index;
